<template>
      <modal
        @close="$emit('close')"
        :close-on-click="true"
        :is-open="true"
        class="image-modal image-modal--roomtype"
      >
        <image-rotator
          :images="images"
          :pagination-enabled="true"
          :thumbnail="false"
          :enableKeys="true"
        ></image-rotator>
      </modal>
  </template>
  
  <script>
  import ImageRotator from "./image-rotator.vue";
  import Modal from "./modal.vue";
  
  export default {
    props: {
      images: {
        type: [Object, Array],
        default() {
          return [];
        },
      },
    },
    components: {
      ImageRotator,
      Modal,
    },
  };
  </script>
  